<ng-container>
  <mat-expansion-panel [expanded]="isExpanded" class="catalog-expansion-panel" [disabled]="disabled">
    <mat-expansion-panel-header>
      <h2>{{ title }}</h2>
    </mat-expansion-panel-header>
    <mat-checkbox *ngFor="let filter of filters" value="{{ filter.filterKey }}" [disabled]="filter.disabled || disabled"
      (change)="onCheckboxChanged($event, filter)">
      {{ filter.filterDisplayText }}
    </mat-checkbox>
  </mat-expansion-panel>
</ng-container>

<ng-template #notExpanded>
  <div class="header">
    <h2>{{ title }}</h2>
  </div>
  <div class="content">
    <mat-checkbox *ngFor="let filter of filters" value="{{ filter.value }}"
      (change)="onCheckboxChanged($event, filter)">
      {{ filter.label }}
    </mat-checkbox>
  </div>
</ng-template>